import React, { useEffect, useState } from 'react';
import { TiPlus } from "react-icons/ti";
import { RiDeleteBin6Line } from "react-icons/ri";
import Pagination from "./Pagination";
import { useNavigate } from 'react-router-dom';
import { getAllPartner, deletePartner, getAllAdmin } from "../redux/apiCalls/accidentApiCall";
import { useDispatch, useSelector } from 'react-redux';
function Admin() {
      const navigate = useNavigate();
      const dispatch = useDispatch();
  const { accidents, isloading, numberOfAccidents } = useSelector((state) => state.accident);
      const [currentPage, setCurrentPage] = useState(1);
        const [perPage] = useState(9);
  useEffect(() => {
    dispatch(getAllAdmin(currentPage, perPage)).then((response) => {
      console.log("API Response:", response); 
    });
  }, [dispatch, currentPage, perPage]);
  const totalPages = Math.ceil((numberOfAccidents || 0) / perPage);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleAddPartner = () => {
      navigate("/addAdmin");
    };

        const handleDelete = (id) => {
          if (window.confirm("Bist du sicher, dass du diesen Partner löschen willst?")) {
            dispatch(deletePartner(id)); 
          }
        };
        const admin = JSON.parse(sessionStorage.getItem("user"));
        
  return (
    <div className="flex flex-col w-full h-[100%]">
    {/* Header Section */}
    <div className="flex flex-col w-full">
      <div className="pl-2 md:pl-5 flex flex-col md:flex-row text-center justify-between w-full pt-2 items-center">
        <div className="mb-2 md:mb-0">
          <h1 className="font-montserrat text-xl md:text-2xl font-[900] pt-9 ">Admin Übersicht</h1>
        </div>
        <div className="flex flex-col md:flex-row mr-0 md:mr-5 justify-between w-full md:w-1/3 space-y-2 md:space-y-0">
          <button
            onClick={handleAddPartner}
            className="border border-black bg-yellow-300 rounded-lg w-full md:w-36 h-9 text-sm flex items-center justify-center mx-auto"
          >
            <TiPlus />
            <span className="ml-1">Neue Admin</span>
          </button>
          <div className="flex items-center justify-center md:justify-end">
            <div className="text-center md:text-right">
              <h4 className="text-sm">{admin.username}</h4>
              <p className="text-xs text-gray-600">{admin.role}</p>
            </div>
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-gray-800 flex justify-center items-center ml-2">
              <img src={admin.profilePhoto?.url} alt="img-pro" className="w-full h-full rounded-[50%]" />
            </div>
          </div>
        </div>
      </div>
      <div className="border-b border-black w-full mt-3"></div>
    </div>
    {/* Table Section */}
    <div className="overflow-x-auto pt-5 px-2 md:px-0">
      <table className="min-w-full border border-gray-300">
        <thead className="bg-gradient-to-b from-[#3a3a3a] to-[#1a1a1a] text-white">
          <tr>
            <th className="px-2 py-2 text-left border-b border-gray-400 text-sm md:text-base">Name</th>
            <th className="px-2 py-2 text-left border-b border-gray-400 text-sm md:text-base">Email</th>
            <th className="px-2 py-2 text-center border-b border-gray-400">Aktion</th>
          </tr>
        </thead>
                <tbody>
                {accidents?.users?.length ? (
    accidents.users.map((admin) => (
      <tr key={admin.id} className="bg-gray-100">
        <td className="px-2 py-2 font-[700] border-b border-gray-300 text-sm md:text-base">
          {admin.username}
        </td>
        <td className="px-2 py-2 font-[700] border-b border-gray-300 hidden md:table-cell">
          {admin.email}
        </td>
        <td className="px-2 py-2 text-center border-b border-gray-300 space-x-1 md:space-x-2">
          <button 
            onClick={() => handleDelete(admin.id)} 
            className="text-red-500 hover:text-red-700"
          >
            <RiDeleteBin6Line className="text-lg md:text-xl" />
          </button>
        </td>
      </tr>
    ))
  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                      Ich bin ein Administrator in Philple.
                      </td>
                    </tr>
                  )}
                </tbody>
      </table>
    </div>
    <Pagination
      totalPages={totalPages}
      currentPage={currentPage}
      onPageChange={handlePageChange}
    />
  </div>
  )
}

export default Admin
